module.exports = "<!-- status of env next to the icon -->\n<div class=\"iconLabel\" *ngIf=\"icon != 'managed'\">\n    <i class=\"dbm dbm-{{icon}} customIcon {{customClass}}\"></i>\n    <span class=\"{{textClass}}\">{{label}}</span>\n</div>\n<div class=\"iconLabel\" *ngIf=\"icon == 'managed'\">\n    <i class=\"fa fa-square-o customIcon {{customClass}}\"></i>\n    <span class=\"{{textClass}}\">{{label}}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/icon-label/icon-label.component.html
// module id = 1936
// module chunks = 0